    
if(typeof Swiper !== 'undefined'){

    const image_gallery_swiper = new Swiper('#troxy-modal-swiper', {
        // Default parameters
        slidesPerView: 1,
        spaceBetween: 10,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
            },
            pagination: {
                el: ".swiper-pagination", 
            },
    })

    const openModalAndCreateImageSlides = (index) => {
            // If modal has already been created select element
            const modal = document.querySelector('#troxy-image-modal');
            // Show the modal
            modal.classList.add('show');
            // Create image slides in modal
            createImageSlidesWithinModal();
            // Slide to selected image index
            image_gallery_swiper.slideTo(index,false,false);
    }

    const createImageSlidesWithinModal = () => {

        // Get the swiper wrapper
        const swiper_wrapper = document.querySelector('#troxy-modal-swiper-wrapper');

        if(swiper_wrapper.dataset.isSet !== 'true') {
            // Get all gallery images
            const images = [...document.querySelectorAll('.troxy-image-gallery__image')];
            // Loop through all gallery images
            images.forEach(image => {
            
                // Create a swiper slide to hold image
                const slide = document.createElement('div')
                slide.classList.add('swiper-slide', 'troxy-image-wrapper');
                // Create img element
                const img = document.createElement('img');
                img.src = image.dataset.src;
                img.alt = image.alt;
                img.width = image.width;
                img.height = image.height;
   
                console.log(image.src)

                // Render img within the slide div
                slide.appendChild(img);

                // Render slide in dom as swiper wrapper's child
                swiper_wrapper.appendChild(slide);
                // Populate dataset to show slides have already been created
                swiper_wrapper.dataset.isSet = 'true';
            })
        }
    }

    const toggleModal = () => {
        const modal = document.querySelector('#troxy-image-modal');
        if(modal) {
            modal.classList.toggle('show');
        } else {
            console.log('There is no modal element');
        }
    
    }
}

// const openModalAndCreateChildImage = (img) => {
//        console.log(img);
//     // Construct config object to pass through function later
//     const img_config = {
//         src: img.src,
//         alt: img.alt,
//         width: img.width,
//         height: img.height
//     }

//     // If there is no image modal create the element
//     if(!document.querySelector('#modal-image')) {

//         // Create modal, close btn and image wrapper 
//         const modal = document.createElement('div');
//         const close = document.createElement('button');
//         const wrapper = document.createElement('div');

//         // Assign attributes to new elements
//         modal.id = 'modal-image';
//         modal.classList.add('image-enlarge');
//         close.onclick = () => toggleModal();
//         close.classList.add('close-modal-btn');
//         wrapper.classList.add('image-wrapper');
        
//         const body = document.querySelector('body');
//         // Append the elements to the body and modal
//         body.appendChild(modal);
//         modal.appendChild(close);
//         modal.appendChild(wrapper);

//         // Create populate img element
//         createImageWithinModal(modal, wrapper, img_config);

//         // Add the show class delayed to create animation affect
//         setTimeout(()=> modal.classList.add('show'), 50);

//     } else {
//         // If modal has already been created select element
//         const modal = document.querySelector('#modal-image');
//         // Show the modal
//         modal.classList.add('show');
//         // Select image wrapper
//         const wrapper = modal.querySelector('.image-wrapper');
//         createImageWithinModal(modal, wrapper, img_config);
//     }
    
// }

// const createImageWithinModal = (modal, wrapper, img_config) => {

//     // Deconstruct img config object
//     const { src, alt, width, height } = img_config;

//     // Check if there is already an img element within the modal
//     const previousImg = modal.querySelector('img');
//     // If no img element then create a new element
//     if(!previousImg) {
//         // Create img element
//         const img = document.createElement('img');

//         // Assign attributes to img
//         img.src = src;
//         img.alt = alt;
//         img.width = width;
//         img.height = height;
        
//         // Append img to image wrapper
//         wrapper.appendChild(img);        
//     } else {
//         // If there is already and img element 
//         // Don't create a new element but assign attributes
//         previousImg.src = src;
//         previousImg.alt = alt;
//         previousImg.width = width;
//         previousImg.height = height;
//     }
// }
